package org.lortex.lines.common

actual fun getLocation(): String {
    return ""
}